// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage-bonus-funds-page .dashboard-body {
  padding-bottom: 2rem;
}

.bonus-funds-hero__icon {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: rgba(202, 138, 4, 0.4);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
}

.bonus-funds-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 1.25rem;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
}

.bonus-funds-card__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.bonus-funds-card__title-wrap {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.bonus-funds-card__icon {
  width: 36px;
  height: 36px;
  border-radius: 9px;
  background: rgba(202, 138, 4, 0.12);
  color: #b45309;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bonus-funds-card__title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: #0f172a;
}

.bonus-funds-card__meta {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.bonus-funds-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.8rem;
  font-weight: 700;
  color: #b45309;
  background: rgba(202, 138, 4, 0.12);
  padding: 0.3rem 0.6rem;
  border-radius: 999px;
}

.bonus-funds-stat {
  font-size: 0.85rem;
  color: #475569;
}

.bonus-funds-export-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.45rem 0.85rem;
  font-size: 0.82rem;
  font-weight: 600;
  font-family: inherit;
  color: #fff;
  background: linear-gradient(135deg, #15803d 0%, #22c55e 100%);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.bonus-funds-export-btn:hover:not(:disabled) {
  opacity: 0.95;
}

.bonus-funds-export-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.bonus-funds-toolbar {
  display: flex;
  align-items: flex-end;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.bonus-funds-page-limit {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
}

.bonus-funds-page-limit select {
  min-width: 88px;
  padding: 0.45rem 0.65rem;
  font-size: 0.875rem;
  font-family: inherit;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #fff;
  color: #0f172a;
  cursor: pointer;
}

.bonus-funds-page-limit select:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.bonus-funds-page-limit--footer {
  margin: 0;
}

.bonus-funds-search {
  position: relative;
  flex: 1 1 320px;
  max-width: 480px;
}

.bonus-funds-search i {
  position: absolute;
  left: 0.85rem;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  font-size: 0.9rem;
}

.bonus-funds-search input {
  width: 100%;
  padding: 0.6rem 0.9rem 0.6rem 2.4rem;
  border: 1px solid #d1d5db;
  border-radius: 9px;
  font-size: 0.9rem;
  font-family: inherit;
  outline: none;
}

.bonus-funds-search input:focus {
  border-color: #ca8a04;
  box-shadow: 0 0 0 3px rgba(202, 138, 4, 0.15);
}

.bonus-funds-msg {
  margin: 0 0 0.75rem;
  padding: 0.6rem 0.85rem;
  border-radius: 8px;
  font-size: 0.88rem;
}

.bonus-funds-msg--error {
  background: rgba(220, 38, 38, 0.08);
  color: #b91c1c;
}

.bonus-funds-loading,
.bonus-funds-empty {
  padding: 2rem;
  text-align: center;
  color: #64748b;
  font-size: 0.95rem;
}

.bonus-funds-table-wrap {
  overflow-x: auto;
  border: 1px solid #eef2f7;
  border-radius: 10px;
}

.bonus-funds-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.bonus-funds-table thead th {
  background: #f8fafc;
  color: #475569;
  text-align: left;
  font-weight: 700;
  font-size: 0.74rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  padding: 0.7rem 0.8rem;
  white-space: nowrap;
  border-bottom: 1px solid #e5e7eb;
}

.bonus-funds-table tbody td {
  padding: 0.7rem 0.8rem;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: top;
  color: #1e293b;
}

.bonus-funds-table tbody tr:hover {
  background: #fffdf5;
}

.bonus-funds-table__uuid {
  font-family: "SFMono-Regular", Consolas, monospace;
  font-size: 0.78rem;
  color: #b45309;
  font-weight: 600;
  white-space: nowrap;
}

.bonus-funds-table__num {
  white-space: nowrap;
  font-weight: 600;
}

.bonus-funds-table__date {
  white-space: nowrap;
  color: #64748b;
  font-size: 0.8rem;
}

.bonus-funds-user {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  min-width: 150px;
}

.bonus-funds-user strong {
  color: #0f172a;
  font-weight: 600;
}

.bonus-funds-user span {
  font-size: 0.78rem;
  color: #64748b;
}

.bonus-funds-code {
  background: #f1f5f9;
  padding: 0.15rem 0.45rem;
  border-radius: 6px;
  font-size: 0.78rem;
  color: #334155;
}

.bonus-funds-sub {
  display: block;
  font-size: 0.72rem;
  color: #94a3b8;
  font-weight: 500;
  margin-top: 0.15rem;
  text-transform: capitalize;
}

.bonus-funds-badge {
  display: inline-block;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 0.22rem 0.55rem;
  border-radius: 999px;
  text-transform: capitalize;
  white-space: nowrap;
}

.bonus-funds-badge--on {
  background: rgba(22, 163, 74, 0.12);
  color: #15803d;
}

.bonus-funds-badge--off {
  background: rgba(100, 116, 139, 0.12);
  color: #475569;
}

.bonus-funds-badge--pending {
  background: rgba(202, 138, 4, 0.14);
  color: #b45309;
}

.bonus-funds-tasks {
  display: inline-block;
  font-weight: 700;
  font-size: 0.82rem;
  color: #b45309;
}

.bonus-funds-tasks--done {
  color: #15803d;
}

.bonus-funds-vest {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.8rem;
  white-space: nowrap;
}

.bonus-funds-vest--locked {
  color: #b91c1c;
  font-weight: 600;
}

.bonus-funds-vest--released {
  color: #15803d;
  font-weight: 600;
}

.bonus-funds-vest--avail {
  color: #2563eb;
  font-weight: 600;
}

.bonus-funds-table__action-col {
  text-align: right;
  white-space: nowrap;
}

.bonus-funds-btn-view {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-family: inherit;
  font-size: 0.82rem;
  font-weight: 600;
  padding: 0.4rem 0.7rem;
  border-radius: 7px;
  cursor: pointer;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #b45309;
}

.bonus-funds-btn-view:hover {
  background: #fff7ed;
  border-color: #fdba74;
}

.bonus-funds-actions {
  display: inline-flex;
  gap: 0.4rem;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.bonus-funds-btn-approve {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-family: inherit;
  font-size: 0.82rem;
  font-weight: 600;
  padding: 0.4rem 0.75rem;
  border-radius: 7px;
  cursor: pointer;
  border: 1px solid #15803d;
  background: #16a34a;
  color: #fff;
}

.bonus-funds-btn-approve:hover:not(:disabled) {
  background: #15803d;
}

.bonus-funds-btn-approve:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.bonus-funds-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding: 1rem 0 0;
}

.bonus-funds-pagination__nav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.bonus-funds-pagination__info {
  font-size: 0.85rem;
  color: #475569;
}

.bonus-funds-btn-outline {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 600;
  padding: 0.45rem 0.85rem;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid #d1d5db;
  background: #fff;
  color: #334155;
}

.bonus-funds-btn-outline:hover:not(:disabled) {
  background: #f8fafc;
}

.bonus-funds-btn-outline:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ===== Detail modal ===== */
.bonus-funds-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  z-index: 1050;
}

.bonus-funds-modal {
  background: #fff;
  border-radius: 16px;
  width: 100%;
  max-width: 760px;
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.3);
}

.bonus-funds-modal__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.1rem 1.3rem;
  border-bottom: 1px solid #eef2f7;
  background: linear-gradient(135deg, #fffbeb, #fff);
}

.bonus-funds-modal__head h2 {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  color: #0f172a;
}

.bonus-funds-modal__sub {
  margin: 0.2rem 0 0;
  font-size: 0.82rem;
  color: #64748b;
}

.bonus-funds-modal__close {
  border: none;
  background: #f1f5f9;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  cursor: pointer;
  color: #475569;
  flex-shrink: 0;
}

.bonus-funds-modal__close:hover {
  background: #e2e8f0;
}

.bonus-funds-modal__body {
  padding: 1.1rem 1.3rem 1.4rem;
  overflow-y: auto;
}

.bonus-funds-detail__section {
  margin-bottom: 1.25rem;
}

.bonus-funds-detail__section:last-child {
  margin-bottom: 0;
}

.bonus-funds-detail__section h3 {
  margin: 0 0 0.6rem;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #b45309;
}

.bonus-funds-detail__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 0.75rem;
  margin: 0;
}

.bonus-funds-detail__item dt {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #94a3b8;
  margin-bottom: 0.2rem;
  font-weight: 600;
}

.bonus-funds-detail__item dd {
  margin: 0;
  font-size: 0.9rem;
  color: #1e293b;
  font-weight: 600;
  word-break: break-word;
}

/* ===== Approve modal ===== */
.bonus-funds-modal--sm {
  max-width: 520px;
}

.bonus-funds-modal__foot {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.6rem;
  padding: 0.9rem 1.3rem;
  border-top: 1px solid #eef2f7;
  background: #f8fafc;
}

.bonus-funds-modal__foot-note {
  margin: 0;
  margin-right: auto;
  font-size: 0.8rem;
  color: #b45309;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}

.bonus-funds-approve-summary {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-bottom: 1.1rem;
}

.bonus-funds-approve-summary span {
  flex: 1 1 120px;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #94a3b8;
  background: #f8fafc;
  border: 1px solid #eef2f7;
  border-radius: 9px;
  padding: 0.6rem 0.7rem;
  font-weight: 600;
}

.bonus-funds-approve-summary strong {
  font-size: 0.95rem;
  color: #0f172a;
  text-transform: none;
  letter-spacing: 0;
}

.bonus-funds-approve-label {
  margin: 0 0 0.6rem;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #475569;
}

.bonus-funds-mode-options {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.bonus-funds-mode {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  text-align: left;
  font-family: inherit;
  padding: 0.75rem 0.85rem;
  border: 1.5px solid #e2e8f0;
  border-radius: 11px;
  background: #fff;
  cursor: pointer;
  position: relative;
  transition: border-color 0.15s, background 0.15s;
}

.bonus-funds-mode:hover:not(:disabled) {
  border-color: #cbd5e1;
}

.bonus-funds-mode--active {
  border-color: #16a34a;
  background: #f0fdf4;
}

.bonus-funds-mode:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.bonus-funds-mode__icon {
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  border-radius: 9px;
  background: rgba(22, 163, 74, 0.12);
  color: #15803d;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
}

.bonus-funds-mode__text {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.bonus-funds-mode__text strong {
  font-size: 0.92rem;
  color: #0f172a;
}

.bonus-funds-mode__text span {
  font-size: 0.78rem;
  color: #64748b;
}

.bonus-funds-mode__check {
  margin-left: auto;
  color: #16a34a;
  font-size: 1.1rem;
}

.bonus-funds-approve-result {
  text-align: center;
  padding: 0.5rem 0 0.25rem;
}

.bonus-funds-approve-result > i {
  font-size: 2.6rem;
  color: #16a34a;
  margin-bottom: 0.5rem;
}

.bonus-funds-approve-result h3 {
  margin: 0 0 1rem;
  font-size: 1.05rem;
  color: #0f172a;
}

.bonus-funds-approve-result .bonus-funds-detail__grid {
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/System/ManageBonusFundsPage.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kDAAkD;EAClD,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;EACtB,gCAAgC;EAChC,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;EACxB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".manage-bonus-funds-page .dashboard-body {\n  padding-bottom: 2rem;\n}\n\n.bonus-funds-hero__icon {\n  flex-shrink: 0;\n  width: 52px;\n  height: 52px;\n  border-radius: 12px;\n  background: rgba(202, 138, 4, 0.4);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.3rem;\n}\n\n.bonus-funds-card {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  padding: 1.25rem;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);\n}\n\n.bonus-funds-card__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.bonus-funds-card__title-wrap {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n}\n\n.bonus-funds-card__icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 9px;\n  background: rgba(202, 138, 4, 0.12);\n  color: #b45309;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.bonus-funds-card__title {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.bonus-funds-card__meta {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.bonus-funds-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: #b45309;\n  background: rgba(202, 138, 4, 0.12);\n  padding: 0.3rem 0.6rem;\n  border-radius: 999px;\n}\n\n.bonus-funds-stat {\n  font-size: 0.85rem;\n  color: #475569;\n}\n\n.bonus-funds-export-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.45rem 0.85rem;\n  font-size: 0.82rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: #fff;\n  background: linear-gradient(135deg, #15803d 0%, #22c55e 100%);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.bonus-funds-export-btn:hover:not(:disabled) {\n  opacity: 0.95;\n}\n\n.bonus-funds-export-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.bonus-funds-toolbar {\n  display: flex;\n  align-items: flex-end;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  margin-bottom: 1rem;\n}\n\n.bonus-funds-page-limit {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #64748b;\n}\n\n.bonus-funds-page-limit select {\n  min-width: 88px;\n  padding: 0.45rem 0.65rem;\n  font-size: 0.875rem;\n  font-family: inherit;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  background: #fff;\n  color: #0f172a;\n  cursor: pointer;\n}\n\n.bonus-funds-page-limit select:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.bonus-funds-page-limit--footer {\n  margin: 0;\n}\n\n.bonus-funds-search {\n  position: relative;\n  flex: 1 1 320px;\n  max-width: 480px;\n}\n\n.bonus-funds-search i {\n  position: absolute;\n  left: 0.85rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #94a3b8;\n  font-size: 0.9rem;\n}\n\n.bonus-funds-search input {\n  width: 100%;\n  padding: 0.6rem 0.9rem 0.6rem 2.4rem;\n  border: 1px solid #d1d5db;\n  border-radius: 9px;\n  font-size: 0.9rem;\n  font-family: inherit;\n  outline: none;\n}\n\n.bonus-funds-search input:focus {\n  border-color: #ca8a04;\n  box-shadow: 0 0 0 3px rgba(202, 138, 4, 0.15);\n}\n\n.bonus-funds-msg {\n  margin: 0 0 0.75rem;\n  padding: 0.6rem 0.85rem;\n  border-radius: 8px;\n  font-size: 0.88rem;\n}\n\n.bonus-funds-msg--error {\n  background: rgba(220, 38, 38, 0.08);\n  color: #b91c1c;\n}\n\n.bonus-funds-loading,\n.bonus-funds-empty {\n  padding: 2rem;\n  text-align: center;\n  color: #64748b;\n  font-size: 0.95rem;\n}\n\n.bonus-funds-table-wrap {\n  overflow-x: auto;\n  border: 1px solid #eef2f7;\n  border-radius: 10px;\n}\n\n.bonus-funds-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.85rem;\n}\n\n.bonus-funds-table thead th {\n  background: #f8fafc;\n  color: #475569;\n  text-align: left;\n  font-weight: 700;\n  font-size: 0.74rem;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  padding: 0.7rem 0.8rem;\n  white-space: nowrap;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.bonus-funds-table tbody td {\n  padding: 0.7rem 0.8rem;\n  border-bottom: 1px solid #f1f5f9;\n  vertical-align: top;\n  color: #1e293b;\n}\n\n.bonus-funds-table tbody tr:hover {\n  background: #fffdf5;\n}\n\n.bonus-funds-table__uuid {\n  font-family: \"SFMono-Regular\", Consolas, monospace;\n  font-size: 0.78rem;\n  color: #b45309;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.bonus-funds-table__num {\n  white-space: nowrap;\n  font-weight: 600;\n}\n\n.bonus-funds-table__date {\n  white-space: nowrap;\n  color: #64748b;\n  font-size: 0.8rem;\n}\n\n.bonus-funds-user {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n  min-width: 150px;\n}\n\n.bonus-funds-user strong {\n  color: #0f172a;\n  font-weight: 600;\n}\n\n.bonus-funds-user span {\n  font-size: 0.78rem;\n  color: #64748b;\n}\n\n.bonus-funds-code {\n  background: #f1f5f9;\n  padding: 0.15rem 0.45rem;\n  border-radius: 6px;\n  font-size: 0.78rem;\n  color: #334155;\n}\n\n.bonus-funds-sub {\n  display: block;\n  font-size: 0.72rem;\n  color: #94a3b8;\n  font-weight: 500;\n  margin-top: 0.15rem;\n  text-transform: capitalize;\n}\n\n.bonus-funds-badge {\n  display: inline-block;\n  font-size: 0.72rem;\n  font-weight: 700;\n  padding: 0.22rem 0.55rem;\n  border-radius: 999px;\n  text-transform: capitalize;\n  white-space: nowrap;\n}\n\n.bonus-funds-badge--on {\n  background: rgba(22, 163, 74, 0.12);\n  color: #15803d;\n}\n\n.bonus-funds-badge--off {\n  background: rgba(100, 116, 139, 0.12);\n  color: #475569;\n}\n\n.bonus-funds-badge--pending {\n  background: rgba(202, 138, 4, 0.14);\n  color: #b45309;\n}\n\n.bonus-funds-tasks {\n  display: inline-block;\n  font-weight: 700;\n  font-size: 0.82rem;\n  color: #b45309;\n}\n\n.bonus-funds-tasks--done {\n  color: #15803d;\n}\n\n.bonus-funds-vest {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  font-size: 0.8rem;\n  white-space: nowrap;\n}\n\n.bonus-funds-vest--locked {\n  color: #b91c1c;\n  font-weight: 600;\n}\n\n.bonus-funds-vest--released {\n  color: #15803d;\n  font-weight: 600;\n}\n\n.bonus-funds-vest--avail {\n  color: #2563eb;\n  font-weight: 600;\n}\n\n.bonus-funds-table__action-col {\n  text-align: right;\n  white-space: nowrap;\n}\n\n.bonus-funds-btn-view {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-family: inherit;\n  font-size: 0.82rem;\n  font-weight: 600;\n  padding: 0.4rem 0.7rem;\n  border-radius: 7px;\n  cursor: pointer;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: #b45309;\n}\n\n.bonus-funds-btn-view:hover {\n  background: #fff7ed;\n  border-color: #fdba74;\n}\n\n.bonus-funds-actions {\n  display: inline-flex;\n  gap: 0.4rem;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n}\n\n.bonus-funds-btn-approve {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-family: inherit;\n  font-size: 0.82rem;\n  font-weight: 600;\n  padding: 0.4rem 0.75rem;\n  border-radius: 7px;\n  cursor: pointer;\n  border: 1px solid #15803d;\n  background: #16a34a;\n  color: #fff;\n}\n\n.bonus-funds-btn-approve:hover:not(:disabled) {\n  background: #15803d;\n}\n\n.bonus-funds-btn-approve:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.bonus-funds-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  padding: 1rem 0 0;\n}\n\n.bonus-funds-pagination__nav {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.bonus-funds-pagination__info {\n  font-size: 0.85rem;\n  color: #475569;\n}\n\n.bonus-funds-btn-outline {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-family: inherit;\n  font-size: 0.85rem;\n  font-weight: 600;\n  padding: 0.45rem 0.85rem;\n  border-radius: 8px;\n  cursor: pointer;\n  border: 1px solid #d1d5db;\n  background: #fff;\n  color: #334155;\n}\n\n.bonus-funds-btn-outline:hover:not(:disabled) {\n  background: #f8fafc;\n}\n\n.bonus-funds-btn-outline:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ===== Detail modal ===== */\n.bonus-funds-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  z-index: 1050;\n}\n\n.bonus-funds-modal {\n  background: #fff;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 760px;\n  max-height: 88vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.3);\n}\n\n.bonus-funds-modal__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1.1rem 1.3rem;\n  border-bottom: 1px solid #eef2f7;\n  background: linear-gradient(135deg, #fffbeb, #fff);\n}\n\n.bonus-funds-modal__head h2 {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.bonus-funds-modal__sub {\n  margin: 0.2rem 0 0;\n  font-size: 0.82rem;\n  color: #64748b;\n}\n\n.bonus-funds-modal__close {\n  border: none;\n  background: #f1f5f9;\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  cursor: pointer;\n  color: #475569;\n  flex-shrink: 0;\n}\n\n.bonus-funds-modal__close:hover {\n  background: #e2e8f0;\n}\n\n.bonus-funds-modal__body {\n  padding: 1.1rem 1.3rem 1.4rem;\n  overflow-y: auto;\n}\n\n.bonus-funds-detail__section {\n  margin-bottom: 1.25rem;\n}\n\n.bonus-funds-detail__section:last-child {\n  margin-bottom: 0;\n}\n\n.bonus-funds-detail__section h3 {\n  margin: 0 0 0.6rem;\n  font-size: 0.8rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #b45309;\n}\n\n.bonus-funds-detail__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 0.75rem;\n  margin: 0;\n}\n\n.bonus-funds-detail__item dt {\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: #94a3b8;\n  margin-bottom: 0.2rem;\n  font-weight: 600;\n}\n\n.bonus-funds-detail__item dd {\n  margin: 0;\n  font-size: 0.9rem;\n  color: #1e293b;\n  font-weight: 600;\n  word-break: break-word;\n}\n\n/* ===== Approve modal ===== */\n.bonus-funds-modal--sm {\n  max-width: 520px;\n}\n\n.bonus-funds-modal__foot {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.6rem;\n  padding: 0.9rem 1.3rem;\n  border-top: 1px solid #eef2f7;\n  background: #f8fafc;\n}\n\n.bonus-funds-modal__foot-note {\n  margin: 0;\n  margin-right: auto;\n  font-size: 0.8rem;\n  color: #b45309;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.bonus-funds-approve-summary {\n  display: flex;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  margin-bottom: 1.1rem;\n}\n\n.bonus-funds-approve-summary span {\n  flex: 1 1 120px;\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: #94a3b8;\n  background: #f8fafc;\n  border: 1px solid #eef2f7;\n  border-radius: 9px;\n  padding: 0.6rem 0.7rem;\n  font-weight: 600;\n}\n\n.bonus-funds-approve-summary strong {\n  font-size: 0.95rem;\n  color: #0f172a;\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n.bonus-funds-approve-label {\n  margin: 0 0 0.6rem;\n  font-size: 0.8rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #475569;\n}\n\n.bonus-funds-mode-options {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n}\n\n.bonus-funds-mode {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  width: 100%;\n  text-align: left;\n  font-family: inherit;\n  padding: 0.75rem 0.85rem;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 11px;\n  background: #fff;\n  cursor: pointer;\n  position: relative;\n  transition: border-color 0.15s, background 0.15s;\n}\n\n.bonus-funds-mode:hover:not(:disabled) {\n  border-color: #cbd5e1;\n}\n\n.bonus-funds-mode--active {\n  border-color: #16a34a;\n  background: #f0fdf4;\n}\n\n.bonus-funds-mode:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.bonus-funds-mode__icon {\n  flex-shrink: 0;\n  width: 38px;\n  height: 38px;\n  border-radius: 9px;\n  background: rgba(22, 163, 74, 0.12);\n  color: #15803d;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n}\n\n.bonus-funds-mode__text {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.bonus-funds-mode__text strong {\n  font-size: 0.92rem;\n  color: #0f172a;\n}\n\n.bonus-funds-mode__text span {\n  font-size: 0.78rem;\n  color: #64748b;\n}\n\n.bonus-funds-mode__check {\n  margin-left: auto;\n  color: #16a34a;\n  font-size: 1.1rem;\n}\n\n.bonus-funds-approve-result {\n  text-align: center;\n  padding: 0.5rem 0 0.25rem;\n}\n\n.bonus-funds-approve-result > i {\n  font-size: 2.6rem;\n  color: #16a34a;\n  margin-bottom: 0.5rem;\n}\n\n.bonus-funds-approve-result h3 {\n  margin: 0 0 1rem;\n  font-size: 1.05rem;\n  color: #0f172a;\n}\n\n.bonus-funds-approve-result .bonus-funds-detail__grid {\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
